import type { ChatMessage } from '#src/types/chat.ts';
import { BaseApiService } from './base-api.service';

export class ConversationApiService extends BaseApiService {
	async forkBriefing(conversationId: string): Promise<string> {
		const { conversation_id } = await this.apiFetch<{ conversation_id: string }>('POST', '/api/briefings/fork', { conversation_id: conversationId });
		return conversation_id;
	}

	chatRequest(
		conversationId: string,
		message: ChatMessage | undefined,
		model: string,
		instance: string,
		signal?: AbortSignal,
		enabledSources?: string[]
	) {
		return this.apiStream('POST', '/api/chat', {
			conversationId,
			...(message ? { message } : {}),
			model,
			instance,
			...(enabledSources?.length ? { enabled_sources: enabledSources } : {})
		}, { signal, dontThrowOnBadStatus: true });
	}

	abortChat(conversationId: string) {
		return this.apiFetch('POST', '/api/chat/abort', { conversationId });
	}

	retryChat(conversationId: string, signal?: AbortSignal, enabledSources?: string[]) {
		return this.apiStream(
			'POST',
			`/api/chat/${conversationId}/retry`,
			{
				...(enabledSources?.length ? { enabled_sources: enabledSources } : {})
			},
			{ signal, dontThrowOnBadStatus: true }
		);
	}
}

export const conversationService = new ConversationApiService();
